import { z } from "zod";
import { SelectListItem } from "../../types/generated/models";

export const buildWaitlistRequestSchema = (clientsCanBookWithAnyPractitioner: boolean) =>
    z.object({
        notes: z.string().max(2000, "Notes must be equal to or less than 2000 characters").nullable().optional(),
        practitioners: clientsCanBookWithAnyPractitioner
            ? z
                  .array(
                      z.object({
                          label: z.string(),
                          value: z.string(),
                      })
                  )
                  .optional()
            : z
                  .array(
                      z.object({
                          label: z.string(),
                          value: z.string(),
                      })
                  )
                  .min(1, "Please select who do you want to book with"),
        locations: z.array(
            z.object({
                label: z.string(),
                value: z.string(),
            })
        ),
        waitlistFor: z
            .object({
                label: z.string(),
                value: z.string(),
            })
            .nullable()
            .optional()
            .refine((data) => data !== null && data.value.length > 0, {
                message: "Please select who do you want to place on the waitlist",
                path: [],
            }),
        availableTimes: z.number(),
    });

export const waitlistRequestFormDefaultValues = {
    waitlistFor: null,
    practitioners: [],
    locations: [],
    notes: "",
    availableTimes: 0,
};

export type WaitlistRequestFormSchemaType = z.infer<ReturnType<typeof buildWaitlistRequestSchema>>;

export type TimeSlotItem = {
    key: number;
    value: number;
    isWeekDay: boolean;
    isChecked: boolean;
};

export const getOptionDisabledForDropdown = (option: SelectListItem, selectedOptions: SelectListItem[]) => {
    const isAnyOptionSelected = selectedOptions?.some((x) => x.value === "any");

    if (isAnyOptionSelected) {
        return option.value !== "any";
    }

    return option.value === "any" && selectedOptions?.length > 0;
};
